import { SidePanelPropertyKey } from './layout.types';

// shared between the section registries (catalog) and the cards (visibility
// consumers) — a typo'd literal key would fail silently since `base:${string}`
// type-checks anything

export const SITE_CARD_PROPERTY_KEYS = {
  serviceLevel: 'base:site-service-level',
  accountManager: 'base:site-account-manager',
  labels: 'base:site-labels',
} as const satisfies Record<string, SidePanelPropertyKey>;

export const CLIENT_CARD_PROPERTY_KEYS = {
  email: 'base:client-email',
  phone: 'base:client-phone',
  labels: 'base:client-labels',
  note: 'base:client-note',
} as const satisfies Record<string, SidePanelPropertyKey>;

export const CONVERSATION_CARD_PROPERTY_KEYS = {
  summary: 'base:summary',
} as const satisfies Record<string, SidePanelPropertyKey>;
